module.exports = __webpack_public_path__ + "img/2-3-who-event-management.401c3e05.jpg";